import { render, staticRenderFns } from "./Ads_InfoStatusBadge.vue?vue&type=template&id=1156b4db&"
import script from "./Ads_InfoStatusBadge.vue?vue&type=script&lang=js&"
export * from "./Ads_InfoStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports